var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accessibility-indicator"},[_c('span',{staticClass:"indicator-green",style:({ width: String(_vm.calculateWidht())+'px', 'background-color':this.color})}),_vm._v(" "),_c('span',{staticClass:"indicator-grey",style:({ width: String(80-_vm.calculateWidht())+'px'})})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e7d98cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/src/productPage/AccessibilityIndicator.vue
// module id = null
// module chunks = 